module.exports = __webpack_public_path__ + "static/media/james_he.5e82391b.png";